import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  auth,
  scenarios as scenarioHelpers,
  modals,
  annotation
} from './../helpers';
import {
  getActivePage,
  getPopUpInfo,
  getJiraTicketsByScenarioName,
  getModalInfoByOwner,
  getModalVisibility,
  getPanelsOpenStatus,
  getPageType
} from '../reducers';
import {
  scenario as scenarioSelectors,
  annotation as annotationSelectors
} from '../selectors';
import {
  annotations as annotationActions,
  collapseAllDetails,
  expandAllDetails,
  jira as jiraActions,
  modal as modalActions,
  setPage,
  togglePanel,
} from '../actions';

import ScenarioListComponent from '../Components/ScenarioListComponent.jsx';
import ConditionalComponent from '../Components/ConditionalComponent';
import { PanelGroup } from 'react-bootstrap';
import AddCommentModalContainer from './AddCommentModalContainer';
import ShowCommentsModalContainer from './ShowCommentsModalContainer';
import ShowHistoryContainer from './ShowHistoryContainer';
import ChangeCommenterNameModalContainer from './ChangeCommenterNameModalContainer';
import RetriggerScenariosModalContainer from './RetriggerScenariosModalContainer.jsx';


class ScenarioListContainer extends React.Component {
    static propTypes = {
      scenarios: PropTypes.object.isRequired,
      columns: PropTypes.array.isRequired,
      trendingColumns: PropTypes.array.isRequired,
      onExpandAllClick: PropTypes.func.isRequired,
      onRetriggerAllClick: PropTypes.func.isRequired,
      onCollapseAllClick: PropTypes.func.isRequired,
      setActivePage: PropTypes.func.isRequired,
      fetchJiraStatus: PropTypes.func.isRequired,
      popUpInfo: PropTypes.object.isRequired,
      activePage: PropTypes.number.isRequired,
      visible: PropTypes.bool.isRequired,
      scenarioName: PropTypes.string.isRequired,
      jiraTickets: PropTypes.array,
      installerPage: PropTypes.bool.isRequired,
      concerningTrendingOnly: PropTypes.bool,
      setConcerningTrendingOnly: PropTypes.func.isRequired,
      currentDispatcherTestsOnly: PropTypes.bool,
      setCurrentDispatcherTestsOnly: PropTypes.func.isRequired,
      annotations: PropTypes.object.isRequired
    };

    componentDidUpdate() {
      const { jiraTickets } = this.props;
      const authToken = auth.getAuthToken();
      if (jiraTickets && authToken && jiraTickets.length !== 0)
        this.props.fetchJiraStatus(authToken, jiraTickets);
    }

    render() {
      const {
        scenarios,
        visible,
        scenarioName,
        installerPage,
        annotations
      } = this.props;

      return (
        <div>
          <AddCommentModalContainer
            addCommentAction={annotationActions.addScenarioComment}
            statusList={annotation.getScenarioStatusList()}
            ticketStatusFunc={(t) => t ? 'Ticket Filed' : null}
            ticketOverridesStatus
          />
          <ChangeCommenterNameModalContainer />
          <ShowCommentsModalContainer
            glyphFunc={(a) => annotation.getAnnotationGlyph(a)}
            removeCommentAction={annotationActions.removeScenarioComment}
            annotations={annotations}
          />
          <RetriggerScenariosModalContainer
            scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_FAILED] || []}
          />
          { visible && scenarioName &&
            <ShowHistoryContainer />
          }
          <PanelGroup id="scenario-list-container">
            <ConditionalComponent condition={!installerPage} >
              <ScenarioListComponent
                {...this.props}
                title="Trending"
                order={1}
                scenarios={scenarios[scenarioHelpers.TRENDING] || []}
                columns={this.props.trendingColumns}
                isColourable
              />
            </ConditionalComponent>

            <ConditionalComponent condition={!installerPage}>
              <ScenarioListComponent
                {...this.props}
                title="Trending Failed"
                order={2}
                scenarios={scenarios[scenarioHelpers.TRENDING_FAILURE] || []}
                columns={this.props.trendingColumns}
                isColourable
              />
            </ConditionalComponent>

            <ScenarioListComponent
              {...this.props}
              title="Failed"
              order={3}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_FAILED] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Error"
              order={4}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_ERROR] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Running"
              order={5}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_RUNNING] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Skipped"
              order={6}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_SKIPPED] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Pending"
              order={7}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_DISPATCHED] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Passed"
              order={8}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_COMPLETED] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Cancelled"
              order={9}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_CANCELLED] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Unknown"
              order={10}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_UNKNOWN] || []}
            />
            <ScenarioListComponent
              {...this.props}
              title="Retriggered"
              order={11}
              scenarios={scenarios &&
              scenarios[scenarioHelpers.SCENARIO_RETRIGGERED] || []}
            />
          </PanelGroup>
        </div>
      );
    }
}
export const mapStateToProps = (state, ownProps) => {
  const historyModalInfo = getModalInfoByOwner(state, modals.owners.scenarioHistory);

  const scenarios = scenarioSelectors.getAllConcerningRegressionScenarios(state);

  const jiraTickets = new Set();
  const failedScenarios = scenarios !== undefined ? Array.from(scenarios).filter(
    s => s.status === scenarioHelpers.SCENARIO_FAILED) : [];
  failedScenarios.forEach(scenario => {
    const tickets = getJiraTicketsByScenarioName(state, scenario.name);
    tickets.forEach(t => jiraTickets.add(t));
  });

  const installerPage = ownProps.installerPage;

  const props = {
    scenarios: scenarioSelectors.regressionScenariosForDisplayByPanel(state),
    columns: ownProps.columns,
    trendingColumns: ownProps.trendingColumns,
    popUpInfo: getPopUpInfo(state),
    activePage: getActivePage(state),
    visible: getModalVisibility(state, modals.owners.scenarioHistory),
    scenarioName: historyModalInfo.scenarioName || '',
    jiraTickets: [...jiraTickets],
    panelsOpenStatus: getPanelsOpenStatus(state) || {},
    installerPage,
    pageType: getPageType(state),
    annotations: annotationSelectors.getAnnotationsByScenarioIdsOrderByDate(state)
  };
  return props;
};


export const mapDispatchToProps = (dispatch) => ({
  onExpandAllClick: (order, scenariosCount) => {
    dispatch(expandAllDetails(order, scenariosCount));
  },
  onCollapseAllClick: (order, scenariosCount) => {
    dispatch(collapseAllDetails(order, scenariosCount));
  },
  onRetriggerAllClick: () => {
    dispatch(modalActions.showRetriggerScenariosModal(true));
  },
  setActivePage: page => {
    if (page > 0)
      dispatch(setPage(page));
  },
  onTogglePanel: (item) => {
    dispatch(togglePanel(item));
  },
  fetchJiraStatus: (authToken, tickets) => {
    dispatch(jiraActions.fetchJiraStatus(authToken, tickets));
  }
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenarioListContainer);


// WEBPACK FOOTER //
// src/Containers/ScenarioListContainer.jsx